import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

// Super Admin: the "Coming Soon" site gate. The password is write-only; the server only reports whether one is set.
export function SiteGateCard() {
  const [g, setG] = useState(null);
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/site-gate").then((r) => setG(r.data)).catch((e) => toast.error(errMsg(e))); }, []);

  const call = async (fn, ok) => {
    setBusy(true);
    try { const { data } = await fn(); setG(data); setPw(""); toast.success(ok); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!g) return null;
  return (
    <section className="admin-card" data-testid="site-gate-card">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-lg text-navy">Site access gate (Coming Soon)</h2>
        <span className={`rounded px-2 py-1 text-xs font-semibold ${g.enabled ? "bg-[#C8102E] text-white" : "bg-gray-200"}`} data-testid="site-gate-status">
          {g.enabled ? "Gate ON – password required" : "Gate OFF – site public"}</span>
      </div>
      <p className="mt-2 text-sm text-gray-600">One shared password protects every public page and API, invitation links included. Admin sign-in stays behind the gate on the website.
        Password: {g.password_set ? "set" : "not set"} · version {g.version}{g.updated_by ? ` · last change ${g.updated_by}` : ""}</p>
      <label className="mt-4 flex items-center gap-2 text-sm">
        <input type="checkbox" checked={g.enabled} disabled={busy || (!g.password_set && !g.enabled)} data-testid="site-gate-toggle"
          onChange={(e) => call(() => api.put("/admin/site-gate", { enabled: e.target.checked }), e.target.checked ? "Gate enabled" : "Gate disabled: site is public")} />
        Require the access password for the whole site
      </label>
      <form className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-end" onSubmit={(e) => { e.preventDefault(); call(() => api.put("/admin/site-gate", { password: pw }), "Password changed: everyone must enter the new one"); }}>
        <div className="flex-1"><label htmlFor="gate-new-pw" className="field-label">{g.password_set ? "Change password" : "Set password"} (min. 10 characters)</label>
          <input id="gate-new-pw" type="password" autoComplete="new-password" minLength={10} maxLength={72} required className="field-input" value={pw}
            onChange={(e) => setPw(e.target.value)} placeholder={g.password_set ? "•••••• saved – type a new one to change" : ""} data-testid="site-gate-password-input" /></div>
        <button className="btn-navy" disabled={busy} data-testid="site-gate-save-password-btn">Save password</button>
      </form>
      <button type="button" className="btn-outline mt-4" disabled={busy} data-testid="site-gate-signout-all-btn"
        onClick={() => window.confirm("Sign everyone out of the site gate? Visitors must enter the password again.") && call(() => api.post("/admin/site-gate/sign-out-all"), "Everyone signed out of the gate")}>
        Sign everyone out</button>
    </section>
  );
}
